import { useRef, useState } from 'preact/hooks'
import { text } from '#contract'
import { useClient } from '../app/client-context.ts'
import { useView } from '../app/use-view.ts'
import { useT } from '../i18n/index.ts'
import { Os } from '../os/os.tsx'
import { useOsStates } from './os-states.ts'
import styles from './phone-device.module.css'
import { useDeviceInput } from './use-device-input.ts'

/**
 * The phone: an iPhone Pro frame around the OS's phone form, sliding up from the bottom of
 * the view with a slight overshoot and back down quicker. Mounted the first time it comes
 * up, then kept (hidden), so it slides both ways. A click outside it puts it away.
 */
export function PhoneDevice() {
  const t = useT()
  const client = useClient()
  const { phone } = useOsStates()
  const open = useView((view) => view.os.open === 'phone')
  const root = useRef<HTMLDivElement>(null)
  const [mounted, setMounted] = useState(open)
  if (open && !mounted) setMounted(true)

  // Back steps back inside the app, then goes home, then puts the phone away.
  useDeviceInput(root, open, () => {
    if (phone.front.value === null) client?.os.close()
    else if (!phone.back()) phone.home()
  })
  if (!mounted) return null

  return (
    <div ref={root} class={styles.device} data-open={open || undefined}>
      <div
        class={styles.scrim}
        onClick={() => {
          client?.os.close()
        }}
      />
      <div
        class={styles.phone}
        role="dialog"
        aria-label={t(text('os.phone'))}
        aria-hidden={!open}
        data-screen={open ? '' : undefined}
      >
        <span class={[styles.button, styles.action].join(' ')} />
        <span class={[styles.button, styles.volumeUp].join(' ')} />
        <span class={[styles.button, styles.volumeDown].join(' ')} />
        <span class={[styles.button, styles.power].join(' ')} />
        <span class={[styles.button, styles.cameraControl].join(' ')} />
        <div class={styles.bezel}>
          <div class={styles.screen}>
            <Os state={phone} />
            <span class={styles.island} />
          </div>
        </div>
      </div>
    </div>
  )
}
